'use strict';

export default function f(config, admin) {
  'ngInject';

  return {
    check() {
      var developmentEnv = false;

      if (config.env === 'local') {
        developmentEnv = true;
      }

      return developmentEnv;
    },

    disablePopUps() {
      var disablePopUps = false;

      if (config.popups === 'disable') {
        disablePopUps = true;
      }

      return disablePopUps;
    },

    deleteAdminCookieInDevelopment() {
      if (this.check()) {
        admin.deleteCookie();
      }
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/development.js